import React from 'react';
import './ExploreLibrary.css';

const ExploreLibrary = () => {
  const SunIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="5" />
      <line x1="12" y1="1" x2="12" y2="3" />
      <line x1="12" y1="21" x2="12" y2="23" />
      <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
      <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
      <line x1="1" y1="12" x2="3" y2="12" />
      <line x1="21" y1="12" x2="23" y2="12" />
      <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
      <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
    </svg>
  );

  const ScrollIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M8 21h12a2 2 0 0 0 2-2v-2H10v2a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v3h4" />
      <path d="M19 17V5a2 2 0 0 0-2-2H4" />
    </svg>
  );

  const GemIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 3h12l4 6-10 12L2 9z" />
      <path d="M11 3 8 9l4 12 4-12-3-6" />
      <path d="M2 9h20" />
    </svg>
  );

  const MoonIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
    </svg>
  );

  const GraduationIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
      <path d="M6 12v5c3 3 9 3 12 0v-5" />
    </svg>
  );

  // const ArrowRightIcon = () => (
  //   <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
  //     <line x1="5" y1="12" x2="19" y2="12" />
  //     <polyline points="12 5 19 12 12 19" />
  //   </svg>
  // );

  return (
    <section className="library-section">
      <h2 className="library-title">Explore our library</h2>
      <div className="library-grid">
        {/* Tile 1 */}
        <div className="library-tile library-tile-pink">
          <span className="library-badge">TRENDING</span>
          <h3 className="library-card-title">Daily Horoscope</h3>
          <p className="library-card-text">Start your day with cosmic insights.</p>
          <div className="library-circle library-circle-1" />
          <div className="library-icon">
            <SunIcon />
          </div>
        </div>

        {/* Tile 2 */}
        <div className="library-tile library-tile-blue">
          <span className="library-badge">POPULAR</span>
          <h3 className="library-card-title">Kundli Analysis</h3>
          <p className="library-card-text">Detailed birth chart report.</p>
          <div className="library-circle library-circle-2" />
          <div className="library-icon">
            <ScrollIcon />
          </div>
        </div>

        {/* Tile 3 */}
        <div className="library-tile library-tile-green">
          <h3 className="library-card-title">Gemstone Advice</h3>
          <p className="library-card-text">Find your lucky stone.</p>
          <div className="library-circle library-circle-3" />
          <div className="library-icon">
            <GemIcon />
          </div>
        </div>

        {/* Tile 4 */}
        <div className="library-tile library-tile-yellow">
          <h3 className="library-card-title">Rahu, Ketu & Shani</h3>
          <p className="library-card-text">Navigate tough transits.</p>
          <div className="library-icon">
            <MoonIcon />
          </div>
        </div>

        {/* Tile 5 */}
        <div className="library-tile library-tile-purple">
          <h3 className="library-card-title">Courses</h3>
          <p className="library-card-text">Learn astrology from experts.</p>
          <span className="library-badge-coming">COMING SOON</span>
          <div className="library-icon">
            <GraduationIcon />
          </div>
        </div>

        {/* Tile 6 */}
        
      </div>
    </section>
  );
};

export default ExploreLibrary;
